// extracted by mini-css-extract-plugin
module.exports = {"container":"OptionSnippet_container__1pJVA","title":"OptionSnippet_title__2SmzX","description":"OptionSnippet_description__2nZld"};